import React, { useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';

import TopBar from '../../components/Navigation/TopBar/TopBar';
import SideBar from '../../components/Navigation/SideBar/SideBar';
import useLayoutStyles from './useLayoutStyles';


const Layout = (props) => {
    const classes = useLayoutStyles();
    const [mobileSideBarOpen, setMobileSideBarOpen] = useState(false);

    const onToggleMenuHandler = (event) => {
        setMobileSideBarOpen((prevState) => !prevState);
    }

    const onSideBarCloseHandler = () => {
        setMobileSideBarOpen(false);
    }

    return (
        <div className={classes.root}>
            <CssBaseline />
            <TopBar onToggleMenu={onToggleMenuHandler}/>
            <SideBar open={mobileSideBarOpen} onClose={onSideBarCloseHandler}/>
            <main className={classes.content}>
                <div className={classes.toolbar}/>
                {props.children}
            </main>
        </div>
    );
};

export default Layout;